import isEmpty from "lodash/isEmpty";
import {
  FeatureFlagName,
  FeatureFlagValue,
} from "utils/constants/featureFlags.constants";
import {
  TAccessCheck,
  TAccessCheckParams,
  TLegalAcknowledgementAccessCheck,
} from "./accessChecks.types";

export const getIsFeatureOn =
  (featureFlag: FeatureFlagName) =>
  ({ featureFlags }: Pick<TAccessCheckParams, "featureFlags">) =>
    featureFlags[featureFlag] === FeatureFlagValue.On;

export const canAccessApp: TAccessCheck = ({ userContext: { user } }) =>
  user?.permissions?.canAccessApp ?? false;

export const canAccessAdminPages: TAccessCheck = ({ userContext: { user } }) =>
  user?.permissions?.canAccessAdminPages ?? false;

export const canEditOtherAccountProperties = ({
  userContext: { user },
}: Pick<TAccessCheckParams, "userContext">) =>
  user?.permissions?.canEditOtherAccountProperties ?? false;

export const canAccessUserManagement: TAccessCheck = ({
  userContext: { user },
}) => user?.permissions?.canAccessUserManagement ?? false;

export const canAccessCCS: TAccessCheck = ({
  userContext: { user },
  featureFlags,
}) =>
  (getIsFeatureOn(FeatureFlagName.EnableAdminConfigurations)({
    featureFlags,
  }) &&
    user?.permissions?.canAccessCCS) ??
  false;

export const canDeleteProject = ({
  userContext: { user },
}: Pick<TAccessCheckParams, "userContext">) =>
  user?.permissions?.canDeleteAnyProjectsForOrganization ?? false;

export const canViewAllContent = ({
  userContext: { user },
}: Pick<TAccessCheckParams, "userContext">) =>
  user?.permissions?.canViewAllContent ?? false;

export const canAccessStructuredDocument: TAccessCheck = ({ featureFlags }) =>
  getIsFeatureOn(FeatureFlagName.FTE42849EnablePDDFStructuredContent)({
    featureFlags,
  });

export const canConfigureExternalUserActivatedAccountNotifications = ({
  userContext: { user },
}: Pick<TAccessCheckParams, "userContext">) =>
  user?.permissions?.canConfigureExternalUserActivatedAccountNotifications ??
  false;

export const hasAcceptedLegalTerms: TLegalAcknowledgementAccessCheck = ({
  legalAcknowledgements,
}) => isEmpty(legalAcknowledgements);

export const hasLegalTermsToAccept: TLegalAcknowledgementAccessCheck = ({
  legalAcknowledgements,
}) => !isEmpty(legalAcknowledgements);

export const canAccessStructuredDocumentReordering: TAccessCheck = ({
  userContext: { user },
  featureFlags,
}) =>
  (getIsFeatureOn(FeatureFlagName.EnableMultipleDocsInStructuredDocSection)({
    featureFlags,
  }) &&
    user?.permissions?.canAccessStructuredDocumentReordering) ??
  false;
